import React from 'react';
import '../App.css';
import { Headerapp } from './/headerapp'
import { Bodyapploginbody} from './/bodyapploginbody'
import { Footerapp } from './/footerapp'

export class Bodyapplogin extends React.Component {
  constructor(props) {
    super(props);
}
state = {
    apiKey:''
}  
  render(){
    return (
      <div className="">
        <Headerapp/>
        <Bodyapploginbody 
          setStateApiKeyP={this.props.setStateApiKeyP} 
          setStateMailP={this.props.setStateMailP}
          setStateAuthCodeP={this.props.setStateAuthCodeP}/>
        <Footerapp/>
      </div>
    );
  }
}

